import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawBigBagModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Big-bag");

		this.name = "big-bag";
		this.icon = svg_big_bag;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-big-bag-module", DrawBigBagModule);

const svg_big_bag = (text) => html`
<svg width="50.00000000000001" height="30.000000000000004" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
<g>
 <title>Layer 1</title>
 <g id="svg_1"/>
 <rect ry="11" rx="11" id="svg_2" height="28" width="48" y="0.90625" x="1" stroke="#000000" fill="#ffff00"/>
 <text font-weight="bold" stroke="#000000" transform="matrix(0.4870681125397027,0,0,0.523258644667269,-9.406527433812894,-0.7158249660012026) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_3" y="37.07843" x="71.32791" stroke-width="0" fill="#000000">${text}</text>
</g>
</svg>

`;
